KROWN.themeName = 'Kingdom';
KROWN.themeVersion = '5.1.4';

// Shopify events

const executeOnceOnDomContentLoaded = ()=>{

	// input helpers

	document.querySelectorAll('input').forEach(elm=>{
		elm.addEventListener('change',e=>{
			if ( e.target.value != '' ) {
				e.target.classList.add('filled');
			} else {
				e.target.classList.remove('filled');
			}
		})
	});
	document.querySelectorAll('input[type="search"]').forEach(elm=>{elm.value=''});

	// a11y tab helper 

	let activeElement = document.activeElement;
	document.addEventListener('keyup', e=>{
		if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
      	activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('regular-select-cover') ||
      	e.target.classList.contains('search-field') ||
      	e.target.classList.contains('product-item__link') ||
      	e.target.classList.contains('content-slider') || 
      	e.target.classList.contains('blog-item__header') ||
      	e.target.classList.contains('toggle__title') ||
      	e.target.tagName == 'INPUT'
      ) {
      	activeElement = e.target;
        e.target.classList.add('focus');
      } 
    }
	});

  // newsletter has jump

	if ( window.location.search == '?customer_posted=true' ) {
		setTimeout(()=>{
			window.scroll({
			  top: document.querySelector('form .alert').offsetTop - 250, 
			  behavior: 'smooth'
			});
		}, 300);
	} else if ( window.location.pathname.includes('/challenge') ) {
		setTimeout(()=>{
			window.scroll({
			  top: 0, 
			  behavior: 'auto'
			});
		}, 300);
	}

}

if ( document.readyState !== 'loading' ) {
	executeOnceOnDomContentLoaded();
} else {
	document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=cart-helper')
			.then(response => response.text())
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				document.querySelector('[data-header-cart-count]').textContent = cartItems.querySelector('[data-cart-count]').textContent;

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

				document.querySelector('.sidebar__cart').show();

		})

	}

}

var seelctor = document.querySelector('.sidebar__container-holder .sidebar__cart-handle');
if (seelctor) {
  seelctor.addEventListener('click',function(e) {
    e.preventDefault();
    var handle = document.querySelector('#shopify-section-sidebar .sidebar__cart-handle');
    if (handle) handle.click();
    return false;
  })
}
var url = window.location.href;
if(url.indexOf('products/') > -1){
  $('.toggle_thumbnails .toggle_thumb_img').on('click',function(e) {
     $(this).closest('.toggle_thumbnails').find('.toggle_thumb_img').removeClass('active');
     $(this).addClass('active');
     var index = $(this).data('index');
     $('.toggles toggle-tab[data-index="'+index+'"] span')[0].click();
     $('.toggles toggle-tab[data-index!="'+index+'"]').removeClass('opened')
     $('.toggles toggle-tab[data-index!="'+index+'"] .toggle__content').slideUp(200) 
     $('.toggles_images .toggle_img[data-index="'+index+'"]').css('opacity','1');
     $('.toggles_images .toggle_img[data-index!="'+index+'"]').css('opacity','0');
  })  
  $('.product__add-to-cart_ctm').on('click', function(e){
    e.preventDefault();
    var btn = document.querySelector('.product__info .product__add-to-cart');
    if (!btn) return;
    var form = btn.closest('form');
    if (form && form.requestSubmit) {
      form.requestSubmit(btn);
    } else {
      btn.click();
    }
  });
   var thumb_len = $('.toggles_wrapper .toggles').length;
console.log(thumb_len);
 if(thumb_len != 0){
  $('.toggles_wrapper .toggles toggle-tab span').mouseenter(function(e) {
    if($(window).width() > 768){
     $(this)[0].click(); 
    }
   })
   $('.toggle_thumbnails .toggle_thumb_img').mouseenter(function(e) {
    if($(window).width() > 768){
      $(this)[0].click();
    }
   })
 }

  $('.sticky_flex_item .product-variant select').on('change',function(e) {
     var main_val = $(this).val();
     $('.product__text product-variants select option[value="'+main_val+'"]').closest('select').val(main_val)
  })
  
  $('.product__text product-variants select').on('change',function(e) {
    var main_val = $(this).val();
    $('.sticky_flex_item .product-variant select option[value="'+main_val+'"]').closest('select').val(main_val)
  })
  
  $('.sticky__cart .product__quantity [name="quantity"]').on('change',function(e) {
     var main_val = $(this).val();
     $('.product__text .product__quantity [name="quantity"]').val(main_val).change();
  })

  $('.product__text .product__quantity [name="quantity"]').on('change',function(e) {
    var main_val = $(this).val();
    $('.sticky__cart .product__quantity [name="quantity"]').val(main_val); 
  })

  $('.sticky__cart .quantity__minus').on('click',function(e) {
    var main_val = $(this).closest('.product__quantity').find('[name="quantity"]').val(); 
    $('.product__text .product__quantity [name="quantity"]').val(main_val).change(); 
  })
  
  $('.sticky__cart .quantity__plus').on('click',function(e) {
    var main_val = $(this).closest('.product__quantity').find('[name="quantity"]').val(); 
    $('.product__text .product__quantity [name="quantity"]').val(main_val).change(); 
  })

  $('.product__text .product__quantity .quantity__plus').on('click',function(e) {
    var main_val = $(this).closest('.product__quantity').find('[name="quantity"]').val();
    $('.sticky__cart .product__quantity [name="quantity"]').val(main_val); 
  })

  $('.product__text .product__quantity .quantity__minus').on('click',function(e) {
    var main_val = $(this).closest('.product__quantity').find('[name="quantity"]').val();
    $('.sticky__cart .product__quantity [name="quantity"]').val(main_val); 
  })
}

// $(window).on("scroll", () => {
//   $(".product__cart-functions").each(function() {
//     //var className = $(this).attr("touching")
//     var offset = $(this).offset().top - $(window).scrollTop() - 150;
//     if (offset <= 0) {
//       $('body').addClass('fixed-cart')
//     } else {
//       $('body').removeClass('fixed-cart')
//     }
//   })
// }).trigger("scroll")

// Quantity stepper
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('qty-minus') || e.target.classList.contains('qty-plus')) {
    const btn = e.target;
    const input = btn.closest('.qty-stepper').querySelector('.qty');
    let val = parseInt(input.value) || 0;
    if (btn.classList.contains('qty-minus')) val = Math.max(0, val - 1);
    if (btn.classList.contains('qty-plus')) val = val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});